/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ComponentSchema } from './ComponentSchema';
import {
    ComponentSchemaFromJSON,
    ComponentSchemaFromJSONTyped,
    ComponentSchemaToJSON,
} from './ComponentSchema';

/**
 * 
 * @export
 * @interface RoleSchema
 */
export interface RoleSchema {
    /**
     * 
     * @type {number}
     * @memberof RoleSchema
     */
    id: number;
    /**
     * 
     * @type {Date}
     * @memberof RoleSchema
     */
    created: Date;
    /**
     * 
     * @type {Date}
     * @memberof RoleSchema
     */
    updated: Date;
    /**
     * 
     * @type {ComponentSchema}
     * @memberof RoleSchema
     */
    component: ComponentSchema;
    /**
     * 
     * @type {string}
     * @memberof RoleSchema
     */
    arn?: string;
    /**
     * 
     * @type {string}
     * @memberof RoleSchema
     */
    roleId?: string;
    /**
     * 
     * @type {string}
     * @memberof RoleSchema
     */
    roleName: string;
}

/**
 * Check if a given object implements the RoleSchema interface.
 */
export function instanceOfRoleSchema(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "created" in value;
    isInstance = isInstance && "updated" in value;
    isInstance = isInstance && "component" in value;
    isInstance = isInstance && "roleName" in value;

    return isInstance;
}

export function RoleSchemaFromJSON(json: any): RoleSchema {
    return RoleSchemaFromJSONTyped(json, false);
}

export function RoleSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): RoleSchema {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'created': (new Date(json['created'])),
        'updated': (new Date(json['updated'])),
        'component': ComponentSchemaFromJSON(json['component']),
        'arn': !exists(json, 'arn') ? undefined : json['arn'],
        'roleId': !exists(json, 'role_id') ? undefined : json['role_id'],
        'roleName': json['role_name'],
    };
}

export function RoleSchemaToJSON(value?: RoleSchema | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'created': (value.created.toISOString()),
        'updated': (value.updated.toISOString()),
        'component': ComponentSchemaToJSON(value.component),
        'arn': value.arn,
        'role_id': value.roleId,
        'role_name': value.roleName,
    };
}

